/* eslint-disable */

import * as React from "react";
import TextField from "@mui/material/TextField";
import * as Styles from "./styles";

interface Props {
  onChange: (e: string) => void;
  value: string;
}

const SearchBar: React.FC<Props> = ({ onChange, value }) => {
  const handleValue = (e: any) => {
    e.preventDefault();
    onChange(e.target.value);
  };

  return (
    <Styles.Container>
      <TextField
        onChange={(e: any) => handleValue(e)}
        value={value}
        size="small"
        fullWidth
        label="Pesquisar por nome"
        id="fullWidth"
      />
      <Styles.SearchIcon />
    </Styles.Container>
  );
};

export default SearchBar;
